import { render } from "./EditFarmerModal1.vue?vue&type=template&id=242abac1&scoped=true"
import script from "./EditFarmerModal1.vue?vue&type=script&lang=js"
export * from "./EditFarmerModal1.vue?vue&type=script&lang=js"

import "./EditFarmerModal1.vue?vue&type=style&index=0&id=242abac1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242abac1"]])

export default __exports__